import cls from 'classnames';
import * as React from 'react';
import { IconChevronDown } from 'ssc-ui-react/es/components/icon';

import { $gt } from '@/common/appCtx';

import styles from './index.module.less';

export interface CollapseProps {
  rest: number;
  style?: React.CSSProperties;
  isExpanded?: boolean;
  onClick?: (toggle: boolean) => void;
}

const Collapse: React.FC<CollapseProps> = (props) => {
  const [toggle, setToggle] = React.useState(false);

  React.useEffect(() => {
    setToggle(props.isExpanded ?? false);
  }, [props.isExpanded]);

  if (props.rest <= 0) return null;
  return (
    <div
      className={styles.collapseWrapper}
      style={props.style}
    >
      <span
        onClick={() => {
          setToggle(!toggle);
          props.onClick?.(!toggle);
        }}
      >
        {toggle ? (
          <span>{$gt('Collapse')}</span>
        ) : (
          <span>{$gt('{rest} More', null, { rest: props.rest })}</span>
        )}
        <IconChevronDown
          className={cls(toggle ? styles.rotateCollapse : styles.collapse)}
        />
      </span>
    </div>
  );
};

export default Collapse;
